import React, {CSSProperties, FC, memo} from "react";
import {DeleteFilled, SaveFilled} from "@ant-design/icons";
import {Button} from "antd";
import i18n from "../../services/i18n";
import css from "./FormButtonsStandard.less";

type FormButtonsStandardProps = {
    onResetFields: () => void;
    loading: boolean;
    disabled?: boolean;
    i18nResetFields?: string;
    i18nSubmit?: string;
    style?: React.CSSProperties;
};

const FormButtonsStandard: FC<FormButtonsStandardProps> = ({
    onResetFields,
    loading,
    disabled = false,
    i18nResetFields = i18n.views.FormButtonsStandard.resetFields(),
    i18nSubmit = i18n.views.FormButtonsStandard.submit(),
    style,
}) => {
    const actualStyle: CSSProperties = {
        padding: 20,
        ...style,
    };

    return (
        <div className={css.root} style={actualStyle}>
            <Button
                danger
                block
                onClick={() => onResetFields()}
                disabled={loading}
            >
                <DeleteFilled />
                {i18nResetFields}
            </Button>
            <Button
                htmlType="submit"
                block
                type="primary"
                loading={loading}
                disabled={disabled}
            >
                <SaveFilled />
                {i18nSubmit}
            </Button>
        </div>
    );
};

export default memo(FormButtonsStandard);
